import Form from './form.vue';
export default Form;


// WEBPACK FOOTER //
// ./src/components/form/index.js